import { createContext, useContext, useState, ReactNode, useCallback } from 'react';

export interface WhatsAppLeadContextValue {
  openModal: (context?: string) => void;
  closeModal: () => void;
  isOpen: boolean;
  leadContext: string;
}

const WhatsAppLeadContext = createContext<WhatsAppLeadContextValue | null>(null);

export function WhatsAppLeadProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [leadContext, setLeadContext] = useState('');

  const openModal = useCallback((context = '') => {
    setLeadContext(context);
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <WhatsAppLeadContext.Provider value={{ openModal, closeModal, isOpen, leadContext }}>
      {children}
    </WhatsAppLeadContext.Provider>
  );
}

export function useWhatsAppLead(): WhatsAppLeadContextValue {
  const ctx = useContext(WhatsAppLeadContext);
  if (!ctx) throw new Error('useWhatsAppLead must be used within WhatsAppLeadProvider');
  return ctx;
}
